import { Interval } from "models/Interval";

export const mergeIntervals = (intervals: Interval[]) => {
  if (intervals.length === 0) return [];

  const converted = intervals.map(
    ([start, end]) => [start.getTime(), end.getTime()] as [number, number],
  );
  converted.sort((a, b) => a[0] - b[0]);

  const merged: [number, number][] = [];
  let currentInterval = converted[0];
  for (let i = 1; i < converted.length; i++) {
    const [currentStart, currentEnd] = currentInterval;
    const [nextStart, nextEnd] = converted[i];

    if (currentEnd >= nextStart) {
      // Overlapping intervals
      currentInterval = [currentStart, Math.max(currentEnd, nextEnd)];
    } else {
      // No overlap
      merged.push(currentInterval);
      currentInterval = converted[i];
    }
  }

  merged.push(currentInterval);

  return merged.map(
    ([start, end]) => [new Date(start), new Date(end)] as Interval,
  );
};
